import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
export function setKeysToFalseExceptKey(object, key) {
  return Object.keys(object).reduce(function (acc, property) {
    if (property === key) acc[property] = object[property];else acc[property] = false;
    return acc;
  }, {});
}